export { default } from "@vendors/CreativeTim/components/Snackbar/Snackbar.js";
